/** Default UFF branding — shown immediately before the API responds. */
export const DEFAULT_BRANDING = {
  companyName: 'United Fidelity Funding',
  primaryColor: '#E10404',
  secondaryColor: null,
  logoUrl: '/assets/uff-logo.svg',
  logoDarkUrl: null,
  faviconUrl: '/assets/pro-portal-mark.svg',
  nmlsId: '34381',
  contactPhone: null,
  contactEmail: null,
  tenantKey: 'bcc',
  isDefault: true,
};
